import React, { useState, useEffect } from "react";
import { errorHandler } from "../../../../../../helpers/Utils";
import {
  orderInvoiceGetClientInfo,
  orderInvoiceSendForClient,
} from "../../../../../../redux/Actions/order_invoice_action";
import { SelectForm } from "../../../../Buttons";
import { BlueButton } from "../../../../ButtonWithLoading";
import TextAreaFieldGroup from "../../../../TextAreaFieldGroup";
import TextInputModal from "../../../../TextInputModal";

export default function SendForClient({ order_id, setType }) {
  useEffect(() => {
    if (!order_id) return;
    setLoading(true);
    orderInvoiceGetClientInfo(order_id).then((res) => {
      if (res.success) {
        setEmail(res.email);
        setMessage(res.message);
        setOrderDocuments(res.order_documents);
      }
      setLoading(false);
    });
  }, [order_id]);

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(undefined);
  const [orderDocuments, setOrderDocuments] = useState([]);
  const onSubmit = async () => {
    try {
      setLoading(true);
      const data = await orderInvoiceSendForClient({
        email,
        message,
        order_id,
        attachment,
      });
      if (data.success) {
        setType("");
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <TextInputModal
        type="email"
        text="Email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextAreaFieldGroup
        placeholder="Message"
        onlyPlaceholder="Enter"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <SelectForm
        placeholder="Attachment"
        onlyPlaceholder="Choose"
        options={orderDocuments}
        value={attachment}
        onChange={(e) => setAttachment(e)}
      />

      <div className="d-flex align-items-center justify-content-end my-2">
        <BlueButton loading={loading} onClick={() => onSubmit()}>
          Send email
        </BlueButton>
      </div>
    </div>
  );
}
